import React from "react";
import "./../HairSubService.css"

const DandruffTreatmentUnderstand = () => {
  return (
    <div className="hairSubServiceWhat">
      <h3>Understanding Dandruff and Its Causes</h3>
      <p>
        Dandruff is not just a cosmetic concern; it can significantly impact
        your confidence and comfort. It is often caused by a combination of
        factors, including:
      </p>
      <li>
        <h6>1. Seborrheic Dermatitis:</h6>
        <p>
           A condition where the scalp becomes oily,
          irritated, and prone to flaking.
        </p>
      </li>
      <li>
        <h6>  2. Fungal Infections:</h6>
        <p>
          Malassezia, a yeast-like fungus, can grow
          excessively on the scalp, leading to dandruff.
        </p>
      </li>
      <li>
        <h6> 3. Dry Scalp:</h6>
        <p>
          Lack of moisture can cause the scalp to flake and itch.
        </p>
      </li>
      <li>
        <h6> 4. Product Build-up:</h6>
        <p>
           Overuse of styling products or inadequate rinsing
          can leave residue, irritating the scalp.
        </p>
      </li>
      <li>
        <h6>  5. Stress and Lifestyle:</h6>
        <p>
          High-stress levels and an unbalanced
          lifestyle can worsen dandruff symptoms.
        </p>
      </li>
      <li>
        <h6>  6. Weather Conditions:</h6>
        <p>
         Bangalore’s fluctuating climate, with its mix
          of humidity and dry spells, can exacerbate dandruff issues.
        </p>
      </li>
    </div>
  );
};

export default DandruffTreatmentUnderstand;
